export const ApiRoutes = {
  // Auth
  AUTH: {
    LOGIN: "/auth/login",
    LOGOUT: "/auth/logout",
    USER: "/auth/user",
    REFRESH: "/auth/refresh",
  },

  DeviceManufacturer: "/device-manufacturer",

  DeviceModel: "/device-model",

  DeviceHWVersion: "/device-hw-version",

  DeviceTag: "/device-tag",

  DeviceCategory: "/device-category",

  Protocol: "/protocol",

  Unit: "/unit",

  DataFormat: "/data-format",

  DeviceType: "/device-type",

  DataType: "/data-type",

  FeatureGroup: "/feature-group",

  DeviceFeature: "/device-feature",

  DeviceThreshold: "/device-threshold",

  ThresholdGroup: "/threshold-group",

  FieldGroup: "/field-group",

  FieldDictionary: "/field-dictionary",

  DeviceLibrary: "/device-library",

  EdgeDevice: "/edge-device",

  Reader: "/reader",

  Schedule: "/schedule",

  Card: "/card",

  Organization: "/organizations",

  AccessPolicy: "/access-policies",

  //Activity Logs
  AcitivityLogs: "/activity-logs",

  //Session Logs
  SessionLogs: "/activity-logs/session-logs",
  SMTP: {
    LIST: "/smtp",
    SEND_MAIL: "/smtp/send-test",
  },
  WebHook: {
    webHook: "/webhook",
    testBtnWebHook: "/webhook/test",
  },

  // temp notifiation email sms etc..
  NotificationConfig: "/notification-config",

  //  NotificationConfig:"/notification-config",
  Services: "/services",
  ServicesTest: "/services/test",
  ServicesSend: "/services/send",

  // user
  User: "/users",
  ForceChangePassword: "/users/force-change-password",
  // Module
  Module: "/module",
  // list module for menu
  ListModule: "/module/enablemodulelist",
  // menu
  Menu: "/menu",
  ParentMenu: "/menu/parent-list",
  //  for roles

  EnabledMenuList: "/menu/enabled",
  AllMenuList: "/menu/list",

  EnabledPermissionList: "/permission/enabled",
  AllPermissionList: "/permission/list",

  // permission
  Permission: "/permission",
  CurrentUserPermissions: "/permission/user/getCurrentUserPermission",
  // roles
  Roles: "/role",
  PlatformRoles: "/role/platform",
  RolesList: "/role/enablerolelist",

  //system-configurations
  SystemConfiguration: "/system-configuration",
  Countries: "/system-configuration/countries",
  TimeZones: "/system-configuration/timezones",

  //date time
  DateTime: "/date-time",
  DateTimeCurrent: "/date-time/current",

  ESL: {
    DynamicFields:"/esl/store-product-data/dynamic-fields",
    StoreProductData: "/esl/store-product-data",
    Gateway:"/esl/gateway",
    Template:"/esl/template",
    Device:"/esl/device",
    DataOperation:"",
    Lcd:"/esl/lcd",
    Store:"/esl/store",
  },

  // Configuration Dashboard template
  DashboardTemplate: "/dashboard-template",
  GetWidgetType: "/dashboard-template/widgets-type",
  GetDashboardTemplate: "/dashboard-template/template",
  GetSensorWidgetData: "/dashboard-template/widgets/sensor",

  // Device Inventory & User Device
  UserDevice: "/user-device",
  DeviceInventory: "/device-inventory",

  //sensor
  Sensor: "sensor-api",
  DoorEventsHistory: "sensor-api/events-history",

  // floor map
  FloorMapAddDevice: "sensor-api/floor-map",
  DeviceWithSensor: "sensor-api/get-device-sensor",
  getFloorList: "floor",
  Site: "sites",

  DeviceThresholdValues: "device-threshold-values",
  UserSensorDeviceRulesDetails: "user-sensor-device-rules-details1",
  OptaDevices: "/opta-devices",
  // NotificationConfig:"/notification-config",
  // NotificationTest:"/notification-config/test",
  serviceTest: "/services/test",
  serviceSend: "/services/send",

  sessions: "/sessions",
  DeviceTrackerHistory: "/sessions/device-history",
  PatientSessionsWithDoctors: "/sessions/patient-sessions/doctors",
  TempPatientSessionsWithDoctors: "/sessions/patient-sessions/t/doctors",

  MinewGoods: "/minew/goods",
  MinewDynamicFields: "/minew/dynamic-fields",
  MinewProduct: "/minew/product",
  MinewUpdateProduct: "/minew/product/update",
};

export const Methods = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  DELETE: "DELETE",
};
